import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import CreditBalanceDisplay from '../credits/CreditBalanceDisplay';
import LoginModal from '../auth/LoginModal';
import RegisterModal from '../auth/RegisterModal';
import './NavigationBar.css';

const NavigationBar = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/'); // Navigate to home instead of login page
  };

  const handleOpenLoginModal = () => {
    setShowLoginModal(true);
    setShowRegisterModal(false);
    document.body.style.overflow = 'hidden'; // Disable scroll when modal is open
  };
  
  const handleOpenRegisterModal = () => {
    setShowRegisterModal(true);
    setShowLoginModal(false);
    document.body.style.overflow = 'hidden'; // Disable scroll when modal is open
  };
  
  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
    document.body.style.overflow = 'auto'; // Re-enable scroll when modal is closed
  };
  
  const handleCloseRegisterModal = () => {
    setShowRegisterModal(false);
    document.body.style.overflow = 'auto'; // Re-enable scroll when modal is closed
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/" className="navbar-item">
            YourPlatform
          </Link>
        </div>
        <div className="navbar-menu">
          <div className="navbar-start">
            <Link to="/" className="navbar-item">
              Home
            </Link>
            {/* Content Creator specific navigation */}
            {user?.user_type === 'content_creator' || user?.user_type === 'super_admin' ? (
                <Link to="/manage-content" className="navbar-item">
                    Manage Content
                </Link>
            ) : null}
          </div>
          <div className="navbar-end">
            {isAuthenticated ? (
              <>
                {/* Credit Balance Display */}
                <div className="navbar-item credit-balance-nav">
                  <CreditBalanceDisplay showLabel={false} size="small" />
                </div>
                
                <div className="navbar-item">
                  <span>Welcome, {user?.full_name || user?.email}</span>
                </div>
                {user?.user_type === 'content_creator' || user?.user_type === 'super_admin' ? (
                    <Link to="/dashboard/content-creator" className="navbar-item">Dashboard</Link>
                ) : null}
                {user?.user_type === 'general_user' && (
                  <Link to="/dashboard/general-user" className="navbar-item">Dashboard</Link>
                )}
                <button onClick={handleLogout} className="navbar-item button is-light">
                  Logout
                </button>
              </>
            ) : (
              <>
                <button type="button" onClick={handleOpenLoginModal} className="navbar-item button is-light">
                  Login
                </button>
                <button type="button" onClick={handleOpenRegisterModal} className="navbar-item button is-primary">
                  Register
                </button>
              </>
            )}
          </div>
        </div>
      </nav>
      
      {/* Login Modal with ability to switch to register */}
      <LoginModal 
        isOpen={showLoginModal} 
        onClose={handleCloseLoginModal}
        onSwitchToRegister={handleOpenRegisterModal} 
      />
      
      {/* Register Modal with ability to switch to login */}
      <RegisterModal 
        isOpen={showRegisterModal} 
        onClose={handleCloseRegisterModal}
        onSwitchToLogin={handleOpenLoginModal} 
      />
    </>
  );
};

export default NavigationBar;